import React, { useState, useRef } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {
  GetUser,
  GetCompany,
  VerifyPolicyNumber,
} from "../../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { CreatePolicyMappingService } from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import { AWS_DIRECTORY_NAME } from "../../../Shared/CommonConstant";
import { FileUploader } from "react-drag-drop-files";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { Box, Button, Divider, Stack } from "@mui/material";
import { AddIcon } from "../../../Resources/Icons/icons";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Styles from "../../User/User.module.scss";
import { useNavigate } from "react-router-dom";

const fileTypes = ["PDF"];
const PaymentDetails = [
  {
    method: "Cash",
    value: 1,
  },
  {
    method: "Online",
    value: 2,
  },
  {
    method: "Cheque",
    value: 3,
  },
  {
    method: "DD",
    value: 4,
  },
];

const CreatePolicyMapping = ({ setOpenDrawer, GetData }) => {
  const initialValues = {
    userId: "",
    issueDate: "",
    companyId: "",
    policyNumber: "",
    totalPremium: "",
    paymentMode: "",
    chequeNumber: "",
    chequeDate: "",
    bankName: "",
    PolicyFile: "",
    OtherFile: "",
  };

  const [userDetails, setUserDetails] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [showPaymentMethod, setShowPaymentMethod] = useState();
  let formRef = useRef();
  const navigate = useNavigate();

  const GetUserDetails = () => {
    GetUser({ isAscending: true }).then((res) => {
      const FilteredData = res.data.map((e) => {
        if (e.isEnabled && e?.userType.includes("user")) {
          return {
            ...e,
            label: e.name,
            value: e._id,
          };
        } else {
          return null;
        }
      });
      setUserDetails(FilteredData.filter(Boolean));
    });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const FilteredData = res.data.map((e) => {
        if (e.isEnabled) {
          return {
            ...e,
            label: e.companyName,
            value: e._id,
          };
        } else {
          return null;
        }
      });
      setCompanyDetails(FilteredData.filter(Boolean));
    });
  };

  const PaymentFunction = (e) => {
    setShowPaymentMethod(e.target.value.value);
    formRef.setFieldValue("paymentMode", e.target.value.method);
  };
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const VerifyPolicyNumberFunction = (e) => {
    VerifyPolicyNumber(e)
      .then((res) => {
        setIsButtonDisabled(true);
      })
      .catch((err) => {
        setIsButtonDisabled(false);
      });
  };

  React.useEffect(() => {
    GetUserDetails();
    GetCompanyDetails();
  }, []);

  const onSubmit = (data) => {
    let formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }
    formData.append(
      AWS_DIRECTORY_NAME.AWS_POLICY_FILE_DIRECTORY_NAME,
      data.PolicyFile
    );
    formData.append(
      AWS_DIRECTORY_NAME.AWS_OTHER_FILE_DIRECTORY_NAME,
      data.OtherFile
    );
    CreatePolicyMappingService(formData)
      .then((res) => {
        setOpenDrawer(false);
        GetData();
      })
      .catch((err) => ToastError("Something Went wrong"));
  };

  const triggerSubmit = () => {
    if (formRef) {
      formRef.submitForm();
    }
  };
  return (
    <>
      <div className={Styles.MainRenderinContainer}>
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"Policy Mapping"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"Create Mapping"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>
        <div className={Styles.formContainer}>
          <Grid
            container
            className="Master_Card_Container"
            sx={{ border: "none" }}
          >
            <Grid
              container
              alignItems={"center"}
              className="Master_Card_Sub_Container"
            >
              <Grid item xs={12} sm={6} md={6}>
                <Typography className="Master_Card_Tittle">
                  {/* {source == "Profile" ? source : "Add User"} */}
                  Create Policy Mapping
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                className="d-flex justify-content-end"
                gap={2}
              >
                <Button
                  className="Master_Card_create_Button w-100"
                  startIcon={
                    <CloseIcon
                      sx={{
                        marginRight: "1.5px",
                      }}
                    />
                  }
                  onClick={() => setOpenDrawer(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="Master_Card_create_Button w-100"
                  startIcon={
                    <AddIcon
                      sx={{
                        marginRight: "1.5px",
                      }}
                    />
                  }
                  onClick={triggerSubmit}
                  disabled={isButtonDisabled}
                >
                  Mapping Required
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider
                sx={{
                  backgroundColor: "#EAECF0",
                  borderWidth: 1,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                  onSubmit(values);
                }}
                innerRef={(ref) => {
                  if (ref) {
                    formRef = ref;
                  }
                }}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form className={Styles.formContent}>
                    <Box
                      sx={{
                        borderBottom: "1px solid #EAECF0",
                        padding: "0 15px",
                      }}
                    >
                      <Typography mt={2} className={Styles.formTitleHead}>
                        User
                      </Typography>

                      <Grid
                        container
                        spacing={2}
                        mt={1} // Style added by Arun
                        mb={2}
                        style={{
                          display: "flex",
                        }}
                      >
                        <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            User Type
                          </Typography>
                          <Autocomplete
                            name="userId"
                            className="AutoComplete_InputBox w-100"
                            disablePortal
                            id="combo-box-demo"
                            options={userDetails}
                            clearIcon={false}
                            onChange={(option, v) =>
                              setFieldValue("userId", v?._id)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select User"
                              />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option?._id === value?._id
                            }
                            renderOption={(props, option) => (
                              <li {...props} key={option._id}>
                                {option?.name}
                              </li>
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        borderBottom: "1px solid #EAECF0",
                        padding: "0 15px",
                      }}
                    >
                      <Typography mt={3} className={Styles.formTitleHead}>
                        Personal Details
                      </Typography>
                      <Grid container spacing={2} sx={{ mb: 3, mt: 1 }}>
                        <Grid item xs={12} sm={3.5} className="datePicker">
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Issue Date
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name="issueDate"
                              className="Date_Picker w-100"
                              onChange={(e) => setFieldValue("issueDate", e.$d)}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={0.7} />
                        <Grid item xs={12} sm={3.6}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Company
                          </Typography>
                          <Autocomplete
                            name="companyId"
                            className="AutoComplete_InputBox w-100"
                            disablePortal
                            id="combo-box-demo"
                            options={companyDetails}
                            onChange={(e, v) =>
                              setFieldValue("companyId", v?._id || "")
                            }
                            clearIcon={false}
                            getOptionLabel={(option) =>
                              option.companyName || ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Company"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={0.7} />
                        <Grid item xs={12} sm={3.5}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Policy Number
                          </Typography>
                          <Field
                            className="textField w-100"
                            name="policyNumber"
                            placeholder="Enter Policy Number"
                            onBlur={(e) =>
                              VerifyPolicyNumberFunction(e.target.value)
                            }
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        borderBottom: "1px solid #EAECF0",
                        padding: "0 15px",
                      }}
                    >
                      <Typography mt={3} className={Styles.formTitleHead}>
                        Premium Details
                      </Typography>

                      <Grid container spacing={2} sx={{ mb: 3, mt: 1 }}>
                        <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Total Premium
                          </Typography>
                          <Field
                            name="totalPremium"
                            placeholder="Enter Total Premium"
                            className="textField w-100"
                          />
                        </Grid>
                        {/* <Grid item xs={12} sm={4}>
                    <FloatLabel label="Select Policy Portal">
                      <Select className="w-100 DropdownField InputFiled">
                        {companyDetails?.map((e) => {
                          return (
                            <MenuItem value={e._id} key={e._id}>
                              {e.companyName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FloatLabel>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FloatLabel label="Select Login Portal">
                      <Select className="w-100 DropdownField InputFiled">
                        {companyDetails?.map((e) => {
                          return (
                            <MenuItem value={e._id} key={e._id}>
                              {e.companyName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FloatLabel>
                  </Grid> */}
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        borderBottom: "1px solid #EAECF0",
                        padding: "0 15px",
                      }}
                    >
                      <Typography mt={3} className={Styles.formTitleHead}>
                        Payment Details
                      </Typography>
                      <Grid container spacing={2} sx={{ mb: 3, mt: 1 }}>
                        <Grid item xs={12} sm={3.5}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Payment Mode
                          </Typography>
                          <Select
                            className="w-100 DropdownField InputFiled"
                            onChange={(e) => PaymentFunction(e)}
                            value={showPaymentMethod}
                            name="paymentMode"
                            placeholder="Select Payment Mode"
                          >
                            <MenuItem value="" disabled>
                              Select Payment Mode
                            </MenuItem>
                            {PaymentDetails?.map((e) => {
                              return (
                                <MenuItem value={e} key={e.value}>
                                  {e.method}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </Grid>
                        {showPaymentMethod === 3 || showPaymentMethod === 4 ? (
                          <>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.6}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Cheque Number
                              </Typography>
                              <Field
                                name="chequeNumber"
                                placeholder="Enter Cheque Number"
                                className="textField w-100"
                              />
                            </Grid>

                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.5} className="datePicker">
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Cheque Date
                              </Typography>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  name="chequeDate"
                                  className="Date_Picker w-100"
                                  onChange={(e) =>
                                    setFieldValue("chequeDate", e.$d)
                                  }
                                />
                              </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={3.5}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Bank Name
                              </Typography>
                              <Field
                                className="textField w-100"
                                placeholder="Enter Bank Name"
                                name="bankName"
                              />
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        borderBottom: "1px solid #EAECF0",
                        padding: "0 15px",
                      }}
                    >
                      <Typography mt={3} className={Styles.formTitleHead}>
                        Files
                      </Typography>
                      <Grid container spacing={2} sx={{ mb: 3, mt: 1 }}>
                        <Grid item xs={12} sm={3.5} className="File-Upload">
                          {/* <Typography>Policy File</Typography> */}
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Policy File
                          </Typography>
                          <FileUploader
                            handleChange={(e) => setFieldValue("PolicyFile", e)}
                            name="PolicyFile"
                            label="Upload Your Policy File"
                            dropMessageStyle={{
                              color: "red",
                              border: "none",
                              borderRadius: "0px",
                            }}
                            // types={fileTypes}
                          />
                          <div
                            className="fileTitle"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              // marginBottom: "-10px",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#959595",
                                fontSize: "12px",
                                fontFamily: "Inter",
                              }}
                            >
                              PDF Files Only
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={0.7} />
                        <Grid item xs={12} sm={3.6} className="File-Upload">
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Other Documents
                          </Typography>
                          <FileUploader
                            handleChange={(e) => setFieldValue("OtherFile", e)}
                            name="OtherFile"
                            label="Upload Your Other documents"
                            dropMessageStyle={{
                              color: "red",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default CreatePolicyMapping;
